import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Carousel from 'Components/UI/Carousel';
import { useDashboardContext } from 'Views/Dashboard/DashboardContext';
import Typography from 'Components/UI/Typography';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box/Box';
import useHomeContext from 'Context/HomeContext';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  rootWhiteBackground: {
    backgroundColor: theme.palette.common.white,
  },
  title: {
    marginBottom: theme.spacing(1),
  },
});

const CuratedContentMobile = ({
  className,
  classes,
  ...rest
}) => {
  const { clientDashboardResource } = useDashboardContext();
  const slides = clientDashboardResource.attr('curatedContentArticles')?.resources()?.list() || [];
  const { hasLegacyDashboardImprovement } = useHomeContext();

  return (
    <Box
      className={classNames(classes.root, className, {
        [classes.rootWhiteBackground]: !hasLegacyDashboardImprovement,
      })}
      {...rest}
    >
      <Typography color="black" variant={'h4'} weight={'bold'} className={classes.title}>{'For You'}</Typography>
      <Carousel slides={slides} />
    </Box>
  );
};

CuratedContentMobile.defaultProps = {
  className: '',
};

CuratedContentMobile.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CuratedContentMobile);
